export default __webpack_public_path__ + "static/media/platform.0a8b1ce8.webp";